import { api } from '../createApi';
import { TagType } from '../TagType';

const TAG_BY_LIST = { type: TagType.Highlight, id: 'LIST' };

api.enhanceEndpoints({
  addTagTypes: [TagType.Highlight as TagType],
  endpoints: {
    getHighlights: {
      providesTags: [TAG_BY_LIST],
    },
    createHighlight: {
      invalidatesTags: [TAG_BY_LIST],
    },
  },
});
